<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 基本资料</div>
    <ul class="project-info-list">
      <li>
        <label>申请人所在单位：</label>
        <div class="info-item">{{ form.department.name }}</div>
      </li>
      <li>
        <label>审批申请人：</label>
        <div class="info-item">{{ form.creator.name }}</div>
      </li>
      <li>
        <label>联系方式：</label>
        <div class="info-item">{{ form.creator.mobile }}</div>
      </li>

      <li>
        <label>会议名称：</label>
        <div class="info-item">{{ form.name }}</div>
      </li>
      <li>
        <label>会议地点：</label>
        <div class="info-item">
          <el-tooltip class="item" effect="dark" :content="form.room.deptName+' - '+form.room.address"
            placement="bottom">
            <span>
              <i class="iconfont icon-address"></i>
              <span v-html="form.room.address"></span>
            </span>
          </el-tooltip>
        </div>
      </li>
      <li class="block intro-box">
        <label>会议要求：</label>
        <div class="info-item">{{ form.req }}</div>
      </li>
      <li>
        <label>会议时间：</label>
        <div class="info-item">{{ form.conferenceTime }}</div>
      </li>
      <li>
        <label>会议持续时间：</label>
        <div class="info-item">{{ form.useTime }}分钟</div>
      </li>
      <li class="block intro-box">
        <label>会议资料：</label>
        <div class="info-item">
          <div class="item" v-for="item,i in form.attachments">
            <i class="iconfont icon-link"></i>
            <file-link :item="item"></file-link>
            <a v-if="!isMobile" :href="baseURL+'/common/file/download?dz='+encodeURI(item.fileUrl)"
              style="margin-left:5px;" target="_blank">
              <el-button size="mini">下载</el-button>
            </a>
          </div>
        </div>
      </li>
      <li class="block intro-box">
        <label>参会人员：</label>
        <div class="info-item">
          <div v-html="getUserList(form.users)"></div>
        </div>
      </li>

    </ul>
  </section>
</template>
<script>
  import FileLink from '@/components/FileLink'
  export default {
    components: {
      FileLink,
    },
    props: ['form', 'userData'],
    data() {
      return {
        baseURL: axios.defaults.baseURL,
      }
    },
    mounted() {},
    methods: {
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/user/projectinfo/meetingApply.vue